import { createSlice } from "@reduxjs/toolkit";
export const translationSlice = createSlice({
  name: "translation",
  initialState: "pr",
  reducers: {
    translate: (state, action) => {
      state = action.payload;
      return state
    },
  },
});

export const { translate } = translationSlice.actions;

//why we use this? export const selectLang = (state) => state;

export default translationSlice.reducer;
